export const CommonUsesData = [
  {
    title: "Financial Document Translation",
    detail:
      "Financial translators at Tomedes can support all types of financial institutions, such as banks, brokerage firms, and cryptocurrency platforms with translation services. Financial documents such as income statements, cash flow statements, balance sheets, financial reports, and more can be translated at Tomedes. Just say the word",
    link: "/financial-translation.php",
  },
  {
    title: "Legal Document Translation",
    detail:
      "All types of legal paperwork such as employment contracts, partnership agreements, and corporate bylaws can easily be translated by a legal translator. Legal translators at Tomedes have knowledge of business/corporate law, entertainment law, environmental law, family law, civil rights law, and more. Get started today.",
    link: "/legal-translation.php",
  },
  {
    title: "Medical Document Translation",
    detail:
      "You don't want a financial translator to translate your medical documents. That's why at Tomedes, all medical document translations are done by medical linguistic experts. They can translate documents such as patient information leaflets, medical history records, operative reports, and more. To know more about our medical translators, get started.",
    link: "/medical-translation.php",
  },
  {
    title: "Technical Document Translation",
    detail:
      "Tomedes translators have the know-how to translate your technical documents. Whether it be engineering plans or machine learning modules, Tomedes technical translators can translate the most complex technical documents, equipped with their specific terminologies. Want to know more? Get in touch with us.",
    link: "/technical-translation.php",
  },
];
